import * as React from "react";
import { EmailTopicsPage } from "./EmailTopicsPage";
import { EmailTopicsProvider } from "./context/EmailTopicsContext";

const EmailTopics = () => (
	<EmailTopicsProvider>
		<EmailTopicsPage />
	</EmailTopicsProvider>
);

export default EmailTopics;
